// extracted by mini-css-extract-plugin
export var active = "_ar-d";
export var blink = "_ar-e";
export var container = "_ar-5";
export var controls = "_ar-0";
export var controlsRight = "_ar-1";
export var fakeCursor = "_ar-c";
export var hidden = "_ar-b";
export var quillContainerSmall = "_ar-7";
export var quillEditor = "_ar-6";
export var quillEditorSmall = "_ar-8";
export var quillFormatButtons = "_ar-a";
export var quillToolbar = "_ar-9";
export var removePadding = "_ar-2";
export var state = "_ar-3";
export var stateTitle = "_ar-4";